import { gql } from "@apollo/client";
import CollectionCardFieldsFragment from "~/src/components/collection/graphql/fragments/CollectionCardFieldsFragment";

export default gql`
  query ListAllCollections(
    $searchQuery: String
    $filterByType: CollectionPackaging
    $filterByFeatured: CollectionFeaturedStatus
    $cursor: String
    $limit: Int = 12
    $lastVisitDate: DateTime
  ) {
    listAllCollections(
      searchQuery: $searchQuery
      filterByPackaging: $filterByType
      filterByFeatured: $filterByFeatured
      cursor: $cursor
      limit: $limit
      filterByViewerBookmarkStatus: UNSAVED
    ) {
      items {
        ...CollectionCardFields

        newContentCounters(lastVisitAnchor: LAST_TRACKED_VIEWER_VISIT, lastVisitDate: $lastVisitDate) {
          groupsCount
          productsCount
          projectsCount
          storiesCount
          governmentsCount
        }
      }
      pageInfo {
        cursor
        hasNextPage
      }
      totalCount
    }
  }

  ${CollectionCardFieldsFragment}
`;
